<script>
  import { APP_STATE } from "./core/AppController.js";
  import { useMachine } from "@xstate/svelte";
  import { appController } from "Core/AppController.js";
  import { onMount } from "svelte";

  import { appMachine } from "Core/AppStateMachine.js";

  import PopupManager from "Core/PopupManager.svelte";
  import CoinWidget from "./widget/coin/CoinWidget.svelte";

  import {
    campaingStore,
    statusStore,
    extWinStore,
    settingsStore,
  } from "Store/data.js";

  let popupManagerEl;

  //TODO: merge status and campaing.status
//  $: status = statusStore.status;
  $: campaing = campaingStore.campaign;
  $: settings = settingsStore.settings;


  function onCoinClick() {
    //console.log("app .... onCoinClick 4");
    popupManagerEl.showMenu();
  }

  function onCoinStartDragging() {
    popupManagerEl.pause();
  }
  function onCoinStopDragging() {
    popupManagerEl.resume();
  }

  const appContext = {
//    unsubsribeCampaingStatus: null,
    unsubsribeSettings: null,
    unsubsribeHideSettings: null,
  };

  const { state, send } = useMachine(appMachine.withContext(appContext), {
    actions: {
      activateAppController: (context) => {
        appController.init();

        let unsubscribe = null;
        unsubscribe = statusStore.status.subscribe((value) => {
          //console.log("Status store is: " + value);
          if (value === APP_STATE.INITED) {
            //console.log("unsubsribe...");
            send("onGameReady");
            if (unsubscribe) unsubscribe();
          }
          if (value === APP_STATE.ERROR) {
            send("onError");
            if (unsubscribe) unsubscribe();
          }
        });
      },

      initLSServer: (context) => {
        
        appController.connect();

        let unsubscribe = null;
        unsubscribe = statusStore.status.subscribe((value) => {
          if (value === APP_STATE.CONNECTED) {

            send("onConnected");
            if (unsubscribe) unsubscribe();
          }
        });
      },

      
      subscribeChangeOnActive: (context) => {
        let unsubscribe = null;
        unsubscribe = statusStore.status.subscribe((value) => {
          //console.log("Status store is: " + value);
          if (value === APP_STATE.ERROR) {
            //    console.log("unsubsribe...");
            send("onError");
            if (unsubscribe) unsubscribe();
          }
        });

        // context.unsubsribeCampaingStatus = campaing.subscribe((value) => {
        //   if (value.status !== "ongoing") {
        //     send("onOver");

        //     if (context.unsubsribeCampaingStatus)
        //       context.unsubsribeCampaingStatus();
        //     context.unsubsribeCampaingStatus = null;
        //   }
        // });

        context.unsubsribeSettings = settings.subscribe((value) => {
          if (value.isOverlap) {
            send("onOverlap");
            if (context.unsubsribeSettings) {
              context.unsubsribeSettings();
              context.unsubsribeSettings = null;
            }
          }
        });
      },
      unsubscribeChangeOnActive: (context) => {
        // if (context.unsubsribeCampaingStatus) {
        //   context.unsubsribeCampaingStatus();
        //   context.unsubsribeCampaingStatus = null;
        // }
        if (context.unsubsribeSettings) {
          context.unsubsribeSettings();
          context.unsubsribeSettings = null;
        }
      },
      //*************** Hide **
      subscribeChangeOnHide: (context) => {
        context.unsubsribeHideSettings = settings.subscribe((value) => {
          //console.log("on setting changes ......................... ");
          //console.log(value);
          if (!value.isOverlap) {
            send("onUnOverlap");
            if (context.unsubsribeHideSettings) {
              context.unsubsribeHideSettings();
              context.unsubsribeHideSettings = null;
            }
          }
        });
      },
      unsubscribeChangeOnHide: (context) => {
        if (context.unsubsribeHideSettings) {
          context.unsubsribeHideSettings();
          context.unsubsribeHideSettings = null;
        }
      },
      //*************  OVER *******
      onAppOver: () => {
        window.postMessage({ name: "resume_gameplay" }, "*");
        appController.disconnect();
      },

      //*************  Error *******
      unpauseGame: () => {
        window.postMessage({ name: "resume_gameplay" }, "*");
      },
    },

    guards: {
      hasWins: (context) => campaingStore.hasNewWins(),
      hasNoWins: (context) => !campaingStore.hasNewWins(),
    },
  });

  //$: console.log("state: " + $state.value);

  onMount(() => {
    send("onStart");

    return () => {
      send("onOver");
    };
  });
</script>

<!-- {#if $status} -->

{#if $state.matches("ACTIVE")}
  <CoinWidget
    on:openMenu={onCoinClick}
    on:startDragging={onCoinStartDragging}
    on:stopDragging={onCoinStopDragging}
  />
  <PopupManager bind:this={popupManagerEl} />
{/if}
